export function getMailIconName(statusName: string): string {
  const statusMap: { [key: string]: string } = {
    sent: 'envelope',
    accepted: 'envelope',
    delivered: 'envelope-circle-check',
    failed: 'envelope-dot',
    bounced: 'envelope-dot',
    temporary_fail: 'envelope-dot',
    permanent_fail: 'envelope-dot',
  };

  return statusMap[statusName] ?? 'envelope';
}
